import { writable } from 'svelte/store';
import { localStore } from './localStore'

// 後端API相關參數 
const apiOpt = {
    apiUrl: '',
    apiKey: '',
    storageEndpoint: ''
}
const apiConfig = localStore('api-configuration-3', apiOpt)

// 前端串接入口相關
const queryStr = localStore('query-string', '')
const appVer = localStore('app-version', 'NULL')
const mode = localStore('app-mode', '')
const cipherText = localStore('cipher-text', '')

// 頁面佈局相關
const layoutOpt = {
    navTitle : '循環杯',
    navBackUrl: '',
    showHome: false, 
    showCancel: false,
    showCarousel: true,
    showBanner: false,
}
const layoutOption = localStore('layout-options', layoutOpt)
const skipInfo = localStore('can-skip-infomation', false)

// 會員資訊
const mInfo = {
    gid: '',
    authV: '',
    tel: '',
    foen: '',
    mid:''
 }
const memberInfo = localStore('op-member-info-mid-a', mInfo)

// 表單相關
const valid = localStore('form-valid', false)
const newOrderId =  localStore('nu-order-id', 'NULL')

// 兌換取杯相關
const tempRedeemInfos = localStore('tmp-redeem-infos', [])
const tempSplitInfos = localStore('tmp-split-infos', [])
const buInfo = localStore('bu-qrcode', {})

// 交易紀錄相關
const keepFilter = localStore('keep-filter', 'all')

// 門市地圖定位資訊
const locationInfo = localStore('location-info', {})
const storeInfos = localStore('location-store-list', {})
const mapLoaded = localStore('map-loaded', {})

// 環境設定
const appSetting = localStore('app-setting', {})

// 線上支付token
const token = localStore('payment-token', '')
const inappToken = localStore('inapp-token', '')
const inappTokenCipherText = localStore('inapp-token-ct', '')
const inappTokenAuthV = localStore('inapp-token-authv', '')
// 記錄目前 JWT 的簽發路徑，決定 token 過期時走哪條換發路徑
const inappTokenSource = localStore('inapp-token-source', 'ct') // 'ct' | 'cloudAuth'
const ICP_A2A_MIN_VERSION = '5.74.0'

/**
 * 取得日期字串
 * @param {*} d 
 * @returns 
 */
export function getDateStr(d) {
    return d.split('T')[0].replaceAll('-','/')
}

/**
 * 取得時間字串
 * @param {*} d 
 * @returns 
 */
export function getTimeStr(d) {
    return d.split('T')[1].split('.')[0]
}

/**
 * 檢查是否開放特定功能
 */
export function checkFeature(enabled, gid, list) {
    if (enabled === true) { return true }

    let guestLis = Array.isArray(list) ? list : []
    let matchGID = guestLis.find(el=> el === gid) 
    console.log('matchGID' , matchGID)

    return matchGID !== undefined
}

/**
 * 判斷 ICP 是否走 AppToApp 路徑
 * @param {string} mode
 * @param {string} gid
 * @param {{ guestList?: string[] }} setting
 * @returns {boolean}
 */
export function compareSemver(version = '', targetVersion = '') {
    const versionParts = `${version}`.split('.').map(part => Number.parseInt(part, 10) || 0)
    const targetParts = `${targetVersion}`.split('.').map(part => Number.parseInt(part, 10) || 0)
    const maxLen = Math.max(versionParts.length, targetParts.length)

    for (let i = 0; i < maxLen; i++) {
        const left = versionParts[i] || 0
        const right = targetParts[i] || 0

        if (left > right) { return 1 }
        if (left < right) { return -1 }
    }

    return 0
}

export function shouldUseIcpA2A(version) {
    if (!version) { return false }
    return compareSemver(version, ICP_A2A_MIN_VERSION) >= 0
}

/**
 * 依設定決定 ICP 前端流程 payType
 * @param {string} gid
 * @param {{ icpA2aMode?: string, guestList?: string[] }} setting
 * @returns {'icpo'|'icpo_a2a'}
 */
export function resolveIcpPayType(version) {
    return shouldUseIcpA2A(version) ? 'icpo_a2a' : 'icpo'
}

export {
    apiConfig,
    queryStr,
    appVer,
    mode,
    cipherText,
    layoutOption,
    skipInfo,
    memberInfo,
    valid,
    newOrderId,
    tempRedeemInfos,
    tempSplitInfos,
    buInfo,
    keepFilter,
    locationInfo,
    storeInfos,
    mapLoaded,
    appSetting,
    token,
    inappToken,
    inappTokenCipherText,
    inappTokenAuthV,
    inappTokenSource,
};
